/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, January 10th 2022, 10:05:13 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { ModalProps } from "@mui/material/Modal";
import Slide, { SlideProps } from "@mui/material/Slide"; //Slide Transition
import Paper, { PaperProps } from "@mui/material/Paper";
import { X } from "react-feather";
import { OSDialogCloseButton } from "ui-widgets/dialogs/OSDialogCloseButton";
import { COLORSCHEME } from "theme/styles";

export type SlidingPanelProps = Pick<ModalProps, "open" | "onClose" | "children"> & SlideProps & PaperProps;

/**
 * Using MUI transitions - https://mui.com/components/transitions/#slide. Using ModalProps for typing only.
 *
 * Slide transition can also be combined with MUI Modal - https://mui.com/components/modal/#transitions
 *
 */

export const SlidingPanel = ({ children, open, onClose, direction, sx, className }: SlidingPanelProps) => {
  return (
    <Slide direction={direction ?? "left"} in={open}>
      <Paper sx={sx} elevation={24} className={className}>
        <div style={{ paddingBottom: 50 }}>
          <OSDialogCloseButton
            sx={{ position: "absolute", left: 8, top: 8 }}
            onClick={(e) => onClose(e, "backdropClick")}
            closeIconButtonComponent={<X color={COLORSCHEME.primary} size="18" />}
          />
        </div>

        {children}
      </Paper>
    </Slide>
  );
};
